<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCGallery :h2="title" :slides="slides" />
  </div>
</template>

<script>
import FCGallery from "@/components/patterns/FCGallery";
export default {
  components: {
    FCGallery
  },
  mounted() {
    const ref = this.$store.state.menu.tunnelClub.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.tunnelClub.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.tunnelClub.nav;
    this.onScroll();
  },
  data() {
    return {
      title: "Tunnel Club",
      slides: [
        {
          type: "virtual",
          file: "bg-placeholder1.jpg",
          title: "",
          view: "S_TunnelClub(INT)"
        },
        {
          type: "virtual-map",
          file: "bg-placeholder1.jpg",
          title: "",
          view: "tunnelclub"
        },
        {
          type: "image",
          file: "tunnel1.jpg",
          title: ""
        },
        {
          type: "image",
          file: "tunnel2.jpg",
          title: ""
        },
        {
          type: "image",
          file: "tunnel3.jpg",
          title: ""
        },
        {
          type: "video",
          file: "bg-placeholder1.jpg",
          title: "",
          vimeo: "https://player.vimeo.com/video/430044349"
        },
        {
          type: "image",
          file: "Suite_Tunnel-Club-Seats.jpg",
          title: ""
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-tunnel-intro.jpg");
  background-size: cover;
  background-position: center;
  z-index: 3;
}
</style>